import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  border: 2px solid rgba(31, 248, 8, 0.9);
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.25rem;
  box-shadow: 0px 0px 15px 5px rgba(31, 248, 8, 0.3),
    inset 0px 0px 15px 5px rgba(31, 248, 8, 0.3);
  padding: 0 0.5rem;
  transition: all 0.5s ease-in-out;

  &:hover {
    box-shadow: 0px 0px 15px 5px rgba(31, 248, 8, 0.4),
      inset 0px 0px 15px 5px rgba(31, 248, 8, 0.4);
  }
`;

const CopyrightText = styled.span`
  color: ${({ theme }) =>
    theme.mode === 'dark'
      ? 'var(--dark-color-primary-transparent)'
      : 'var(--light-color-primary)'};
  text-shadow: 0px 0px 10px rgba(64, 248, 8, 1);
  font-family: 'VT323', monospace;
  font-weight: normal;
  font-size: 1.5rem;
`;

const VersionText = styled.span`
  color: ${({ theme }) =>
    theme.mode === 'dark'
      ? 'var(--dark-color-primary-transparent)'
      : 'var(--light-color-primary)'};
  text-shadow: 0px 0px 10px rgba(64, 248, 8, 1);
  font-family: 'VT323', monospace;
  font-weight: normal;
  font-size: 1rem;
`;

export const Footer = () => (
  <FooterContainer>
    <CopyrightText>© {new Date().getFullYear()}, Lukas Bobinas</CopyrightText>
    <VersionText>v0.1.0</VersionText>
  </FooterContainer>
);
